// The small button that lives inside a panel on the request form — "Opnieuw proberen" under a
// failed analysis, and the same under an upload that would not start.
//
// Two elements deep on purpose: the outer button holds the drop shadow while the inner block
// slides down into it on hover, the same chrome the site's own buttons use.
export const buildPanelButton = (label, variant) => {
    const button = document.createElement('button')
    const inner = document.createElement('span')
    const text = document.createElement('span')

    button.type = 'button'
    button.className = `request-form__panel-button request-form__panel-button--${variant}`

    inner.className = 'request-form__panel-button-inner'

    text.dataset.requestPanelButtonLabel = 'true'
    text.textContent = label

    inner.appendChild(text)
    button.appendChild(inner)

    return button
}

export const setPanelButtonLabel = (button, label) => {
    const text = button.querySelector('[data-request-panel-button-label]')

    if (text) {
        text.textContent = label
    }
}
